import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import * as CD from 'app/cd/models/essette-api';

@autoinject()
export class MemberMergeHistoryDetail extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    @bindable()
    protected targetMemberName: string | null = null;

    @bindable({ changeHandler: 'reload' })
    protected mergeDetails: CD.MemberMergeResultDetail[] | null = null;

    protected relatedData: CD.MemberMergeResultDetailRelatedModel[] = [];

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected bind() {
        this.reload();
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////
    protected reload(): void {
        if(this.mergeDetails) {
            this.relatedData = [];
            this.mergeDetails.forEach((mergeDetail) => (mergeDetail.related) ? this.relatedData.push(...mergeDetail.related) : null);
        }
    }

    ////****************** Service Calls ********************************************////

}
